const SHELL_TOOL_NAMES = new Set([
  "bash",
  "exec",
  "exec_command",
  "execute_command",
  "local_shell",
  "powershell",
  "run",
  "run_command",
  "run_shell_command",
  "runcommand",
  "shell",
  "shell_command",
  "terminal",
]);

const CODEX_WRAPPER_HEAD = /^\s*const\s+([A-Za-z_$][\w$]*)\s*=\s*await\s+tools\.(?:exec_command|shell_command)\(/;
const CODEX_WRAPPER_TAIL = /^\s*\);\s*(?:text\(([A-Za-z_$][\w$]*)\);?)?\s*$/;
const MAX_CODEX_WRAPPER_CHARS = 1_000_000;

function commandText(value) {
  if (typeof value === "string") return value.trim() || null;
  if (!Array.isArray(value)) return null;
  const text = value.filter((part) => typeof part === "string").join(" ").trim();
  return text || null;
}

function jsonObjectEnd(source, start) {
  if (source[start] !== "{") return -1;
  let depth = 0;
  let quoted = false;
  let escaped = false;
  for (let i = start; i < source.length; i += 1) {
    const ch = source[i];
    if (quoted) {
      if (escaped) escaped = false;
      else if (ch === "\\") escaped = true;
      else if (ch === '"') quoted = false;
      continue;
    }
    if (ch === '"') {
      quoted = true;
      continue;
    }
    if (ch === "{" || ch === "[") depth += 1;
    else if (ch === "}" || ch === "]") depth -= 1;
    if (depth === 0) return i + 1;
    if (depth < 0) return -1;
  }
  return -1;
}

export function codexWrappedArgs(source) {
  if (typeof source !== "string" || source.length > MAX_CODEX_WRAPPER_CHARS) return null;
  const head = source.match(CODEX_WRAPPER_HEAD);
  if (!head) return null;
  let start = head[0].length;
  while (/\s/.test(source[start] || "")) start += 1;
  const end = jsonObjectEnd(source, start);
  if (end < 0) return null;
  const tail = source.slice(end).match(CODEX_WRAPPER_TAIL);
  if (!tail || (tail[1] && tail[1] !== head[1])) return null;
  try {
    const args = JSON.parse(source.slice(start, end));
    if (!args || typeof args !== "object" || Array.isArray(args)) return null;
    return args;
  } catch {
    return null;
  }
}

function codexWrappedCommand(source) {
  const args = codexWrappedArgs(source);
  return args ? commandText(args.command ?? args.cmd) : null;
}

/**
 * The reason the agent bound to THIS call, when its tool carries one: the
 * Bash tool's `description` input, or the same field inside Codex's exec
 * wrapper. A statement attached to the call outranks any nearby narration.
 */
export function callDescriptionOf(block) {
  if (block?.type !== "tool_use") return null;
  const direct = block.input?.description;
  if (typeof direct === "string" && direct.trim()) return direct.trim();
  if (String(block.name || "").toLowerCase() === "exec") {
    const args = codexWrappedArgs(block.input?.input);
    const described = args?.description;
    if (typeof described === "string" && described.trim()) return described.trim();
  }
  return null;
}

export function shellToolCommand(toolName, input) {
  const name = String(toolName || "").toLowerCase();
  if (!SHELL_TOOL_NAMES.has(name)) return null;
  if (typeof input === "string") return commandText(input);
  if (!input || typeof input !== "object" || Array.isArray(input)) return null;
  const direct = commandText(input.command ?? input.cmd);
  if (direct) return direct;
  return name === "exec" ? codexWrappedCommand(input.input) : null;
}
